<header class="patient-header">
  <div class="header-container">
    <div class="header-left">
      <app-product-logo></app-product-logo>
      <span class="practice-name" *ngIf="practiceName">{{ practiceName }}</span>
    </div>

    <div class="header-right">
      <button
        mat-button
        (click)="handleLanguageClick($event)"
        (menuClosed)="onLanguageMenuClosed()"
        [matMenuTriggerFor]="isMobile ? null : langMenu"
        #langMenuTrigger="matMenuTrigger"
        matTooltip="{{ 'HEADER.TOOLTIP.LANGUAGE_SELECTION' | translate }}"
        color="accent">
        <mat-icon>language</mat-icon>
        {{ selectedLang | uppercase }}
      </button>

      <mat-menu #langMenu="matMenu">
        <button mat-menu-item *ngFor="let lang of appInitService.languageOptions" (click)="changeLanguage(lang)">
          <i [ngClass]="lang.flagIconClass"></i>
          <span class="language-name" [class.selected]="lang.value === selectedLang">{{ lang.viewValue }}</span>
        </button>
      </mat-menu>
    </div>
  </div>
</header>
